import { render } from "./Tabla.vue?vue&type=template&id=db3097ac"
import script from "./Tabla.vue?vue&type=script&lang=js"
export * from "./Tabla.vue?vue&type=script&lang=js"

import "./Tabla.vue?vue&type=style&index=0&id=db3097ac&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__